import BaseApi from "../../../services/baseApi";

class Reporting {
    constructor() {
        this.entity = 'reportDebt';
    }

    getPage() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/'+this.entity+'/list/',
            headers: {'Content-Type': 'application/json'},
        })
    }

    search(buildingId,amountFrom,amountTo){
        let formData=new FormData();
        formData.set("buildingId",buildingId)
        formData.set("amountFrom",amountFrom)
        formData.set("amountTo",amountTo)

        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/search',
            headers: {'Content-Type': 'application/json'},
        })

     }



}
export default new Reporting();
